import { render, staticRenderFns } from "./FormPrecioParcelas.vue?vue&type=template&id=a0bb0200"
import script from "./FormPrecioParcelas.vue?vue&type=script&lang=js"
export * from "./FormPrecioParcelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports